<div class="insurance-banner-wrapper">
  @if (userLang && LINK_TARGET) {
    <div class="banner-shell" [class.mobile-disclaimer-expanded]="mobileDisclaimerExpanded">
      <button
        class="banner-wrapper"
        (click)="openTargetInNewPage()"
        (keydown.enter)="openTargetInNewPage()"
        (keydown.space)="openTargetInNewPage(); $event.preventDefault()"
        [attr.aria-labelledby]="'insurance-banner-slogan'"
        [class.fix-ru]="userLang === 'ru'"
        [class.fix-uk]="userLang === 'uk'"
        [class.fix-en]="userLang === 'en'"
        [class.fix-pl]="userLang === 'pl'">
        <span id="insurance-banner-slogan" class="sr-only" [innerHTML]="'INSURANCE_BANNER.SLOGAN' | translate"> </span>
        <div class="row space-around" inert>
          <div class="slogan-container" [innerHTML]="'INSURANCE_BANNER.SLOGAN' | translate"></div>
          <img src="https://kartapobytu.app/img/597-trimmed.png" alt="" class="bg-container" />
        </div>
        @if (deviceTypeDetected === 'DESKTOP' || deviceTypeDetected === 'TABLET') {
          <div class="row align-center" inert>
            <div class="disclaimer-container" [innerHTML]="'INSURANCE_BANNER.DISCLAIMER' | translate"></div>
          </div>
        }
      </button>
      @if (deviceTypeDetected === 'PHONE') {
        <div
          id="insurance-mobile-disclaimer"
          class="mobile-disclaimer-panel"
          [class.expanded]="mobileDisclaimerExpanded"
          [attr.aria-hidden]="!mobileDisclaimerExpanded">
          <div class="mobile-disclaimer-content">
            <div class="disclaimer-container" [innerHTML]="'INSURANCE_BANNER.DISCLAIMER' | translate"></div>
          </div>
        </div>
        <button
          type="button"
          class="mobile-disclaimer-handle"
          (click)="toggleMobileDisclaimer()"
          [attr.aria-expanded]="mobileDisclaimerExpanded"
          aria-controls="insurance-mobile-disclaimer">
          <span class="sr-only" [innerHTML]="'INSURANCE_BANNER.DISCLAIMER' | translate"></span>
          @if (!mobileDisclaimerWasRevealed) {
            <mat-icon class="attention-icon" fontSet="material-icons-outlined" aria-hidden="true">
              priority_high
            </mat-icon>
          }
          <mat-icon class="chevron-icon" [class.expanded]="mobileDisclaimerExpanded" aria-hidden="true">
            expand_more
          </mat-icon>
        </button>
      }
    </div>
  }
</div>
